import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  invalidRegistration: {
    margin: "2rem 0.5rem 0 0.5rem",
    textAlign: 'center',
    whiteSpace: 'pre-wrap'
  },
  userExists: {
    margin: "0rem 0.5rem 1rem 0.5rem",
    textAlign: 'center',
    whiteSpace: 'pre-wrap',
    "& a": {
      cursor: "pointer"
    }
  },
  root: {
    width: "644px",
    backgroundColor: "white",
    borderRadius: "12px !important",
    padding: "20px 0px 5px 20px",
    marginTop: "39px",

    "& .cguLabel": {
      fontSize: "30px"
    },
    "& .error": {
      textAlign: "center",
      margin: "1rem",
      marginBottom: 0,
      color: theme.error,
      whiteSpace: 'pre-wrap',
    },
    "& .langSelectedRoot": {
      display: "flex",
      gap: "2px",
      position: "relative",
      left: "-5px"
    },
    "& .langSelected": {
      color: "#C6CBD9",
      fontWeight: "bold",
      fontSize: "12px",
    },
    "& .MuiSvgIcon-root": {
      display: "none",
    },
    "& .registrationHeader": {
      width: "90%",
      margin: "0 auto",
      marginTop: "1.5rem",
      display: "flex",

      [theme.breakpoints.down("500")]: {
        width: "95%",
      },

      "& .headerLabel": {
        fontSize: "25px",
        fontWeight: "600",
        marginBottom: "3px"
      },

      "& .headerNotice": {
        fontSize: "14px",
        color: '#7E7E8F',
        fontWeight: "400",
        marginBottom: "14px"
      },

      "& .langSelect": {
        fontSize: "0.75rem",
        fontWeight: "300",
        borderRadius: "10px",
        width: "50px",
        height: "35px",
        position: "relative",
        top: "-15px",

        "& .MuiSelect-select": {
          paddingRight: "1.125rem"
        },
        "& .MuiSelect-icon": {
          fontSize: "1rem",
          top: "calc(50% - 0.5rem)"
        }
      }
    },
    "& .invitationBanner": {
      width: "90%",
      margin: "0 auto",
      marginTop: "0.5rem",
      padding: "12px 16px",
      backgroundColor: "#EAF3EE",
      borderRadius: "12px",
      color: "#16161E",
      fontSize: "14px",
      lineHeight: "1.4",

      [theme.breakpoints.down("500")]: {
        width: "95%",
      },
    },
    "& .establishmentHelp": {
      width: "90%",
      margin: "0 auto",
      marginTop: "1rem",
      color: "#16161E",
      fontSize: "14px",
      lineHeight: "1.4",
      whiteSpace: "pre-wrap",

      "& strong": {
        fontWeight: "600",
      },

      [theme.breakpoints.down("500")]: {
        width: "95%",
      },
    },
    "& .formContainer": {
      width: "90%",
      margin: "0 auto",
      marginTop: "1.5rem",

      [theme.breakpoints.down("500")]: {
        width: "95%",
      },

      "& .MuiGrid-item": {
        marginBottom: "2rem",

        "& input": {
          boxSizing: 'inherit'
        }
      },

      "& label": {
        lineHeight: "1px"
      },

      "& .MuiInputLabel-shrink": {
        transform: "translate(0px, -12px) scale(0.75)"
      },

      "& .react-tel-input": {
        "& input": {
          width: "100%"
        },
        "& .country-list": {
          maxHeight: "16rem",
          "& .search": {
            "& input": {
              marginLeft: "-0.25rem"
            }
          }
        }
      },

      "& legend": {
        maxWidth: "0px"
      },

      "& .cguItem": {
        width: "100%",
        "& .MuiTypography-root": {
          fontSize: "0.75rem"
        }
      },

      "& .MuiFormHelperText-contained": {
        marginLeft: 0
      },

      "& .formBtnGrp": {
        marginBottom: 0,
        position: "relative",
        top: "-25px",

        "& .MuiTypography-root": {
          opacity: 0.7,
          fontSize: "0.75rem"
        },
        "& .MuiButton-root": {
          textTransform: "none",
          padding: "0.375rem 1.5rem",
          "&.loaderComplete": {
            pointerEvents: "none",
            cursor: "inherit",
            opacity: 0.5
          },
          "&.greenBtn": {
            backgroundColor: "#32614F",
            borderRadius: "30px",
            width: "150px",
            position: "relative",
            left: "-25px"
          },
          "&.greenBtn:hover": {
            backgroundColor: "#54CC54",
            color: "#003A22"
          },
          "&.blueBtn:hover": {
            backgroundColor: theme.palette.secondary.main
          }
        }
      },
      "& .phone-error": {
        borderColor: "#f44336"
      },
    },
    // This classes is set to avoid that the textfield labels are hidden by the above field
    "& .input-label": {
      "& .MuiInputLabel-root": {
        overflow: "visible !important",
      },
    },
    "& .input-label-approval": {
      "& .MuiFormHelperText-root": {
        position: "relative",
        top: "-10px"
      },
      "& .MuiInputBase-root": {
        borderRadius: "16px",
        padding: "4px 14px 4px 4px",
        width: "92%",
        marginBottom: "10px",
        marginTop: "5px",
        fontSize: "14px"
      },
      "& .MuiInputLabel-root": {
        overflow: "visible !important",
        color: "#16161E",
        fontWeight: "bold",
        fontSize: "16px",
        fontFamily: "Roboto",
      },
    },
  },
  langItem: {
    fontSize: "0.75rem",
    fontWeight: 300,
    "&.MuiListItem-gutters": {
      padding: "0.125rem 0.75rem"
    },
    "&.hidden": {
      display: "none"
    }
  }
}));